import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Ams } from 'src/app/amsconfig';
import { IToolingListItem, ToolingDef } from 'src/app/core/dto';

@Injectable({
  providedIn: 'root',
})
export class ToolingService {
  private http = inject(HttpClient);

  private get baseUrl(): string {
    return Ams?.Config?.BASE_URL || '';
  }

  getToolings(take = 4000) {
    return this.http.get<IToolingListItem[]>(
      `${this.baseUrl}/_api/tooling?skip=0&take=${take}`
    );
  }

  /** Tooling codes can contain `/` (e.g. "6X2-1/8X2-3/8 ZEE"); encode so they stay one path segment. */
  private toolingUrl(toolingCode: string): string {
    return `${this.baseUrl}/_api/tooling/${encodeURIComponent(toolingCode)}`;
  }

  putTooling(code: string) {
    return this.http.put<ToolingDef>(this.toolingUrl(code), {
      toolingCode: code,
    });
  }

  getTooling(toolingCode: string) {
    return this.http.get<ToolingDef>(this.toolingUrl(toolingCode));
  }

  deleteTooling(toolingCode: string) {
    return this.http.delete<void>(this.toolingUrl(toolingCode));
  }

  updateTooling(toolingCode: string, data) {
    return this.http.patch<ToolingDef>(this.toolingUrl(toolingCode), data);
  }

  changeMachineDetail(toolingCode: string, machineNumber: number, data) {
    return this.http.patch<ToolingDef>(
      `${this.toolingUrl(toolingCode)}/machine/${machineNumber}`,
      { toolingCode, machineNumber, ...data }
    );
  }

  addMachineToTooling(toolingCode: string, machineNumber: number) {
    return this.http.put<ToolingDef>(
      `${this.toolingUrl(toolingCode)}/machine/${machineNumber}`,
      {
        toolingCode,
        machineNumber,
      }
    );
  }

  deleteMachineFromTooling(toolingCode: string, machineNumber: number) {
    return this.http.delete<ToolingDef>(
      `${this.toolingUrl(toolingCode)}/machine/${machineNumber}`
    );
  }
}
